<!-- CLIENTS SECTION - STARTS -->
<section class="important-links">
    <div class="position-relative container-xxl">
        <div class="swiper" id="links-swiper">
            <div class="swiper-wrapper">
                <!-- <ng-container> -->
                    <div class="swiper-slide" *ngFor="let item of impLInk">
                        
                        <div *ngIf="toogaleValue == 'theme-dark'  || toogaleValue == null">
                        <a class="screen-reader" [attr.title]="language=='English'?'View Link':'लिंक देखें'" (click)="goToExtLink(item.uRL)" target="_blank">
                            <img [src]="this.imageUrl+item.logo" alt="link">
                        </a>
                    </div>

                    <div *ngIf="toogaleValue == 'theme-light'">
                        <a class="screen-reader" [attr.title]="language=='English'?'View Link':'लिंक देखें'" (click)="goToExtLink(item.uRL)" target="_blank">
                            <img [src]="this.imageUrl+item.logoForBlackTheme" alt="link">
                        </a>
                    </div>
                    </div>
            </div>
        </div>
        <div class="swiper-button-prev clients-prev"></div>
        <div class="swiper-button-next clients-next"></div>
    </div>
</section>
<!-- CLIENTS SECTION - ENDS -->